import React, { useState, useEffect } from 'react';
import './NoticePage.css';
import { API_URL } from '../lib/config';
import { useNavigate } from 'react-router-dom';
import '../components/SideMenu.css';

function NoticeListPage() {
    const [notices, setNotices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNotices = async () => {
            try {
                const response = await fetch(`${API_URL}/api/notices`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setNotices(data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchNotices();
    }, []);


    if (loading) return <div className="notice-page-container">공지사항을 불러오는 중...</div>;
    if (error) return <div className="notice-page-container error">공지사항을 불러오는데 실패했습니다: {error.message}</div>;

    return (
        <div className="notice-page-container">
            <div id="bright-stars1"></div>
            <div id="bright-stars2"></div>
            <div id="bright-stars3"></div>

            <div className="notice-top-bar">
                <button className="back-button-icon" onClick={()=>navigate(-1)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 19L8 12L15 5" stroke="#333333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <div className="top-bar-title">공지사항</div>
            </div>
            
            <main className="notice-main-content">
                {notices.length === 0 ? (
                    <p>현재 등록된 공지사항이 없습니다.</p>
                ) : (
                    <ul className="notice-list">
                        {notices.map(notice => {
                            const isEdited = new Date(notice.updatedAt) - new Date(notice.createdAt) > 60000;
                            return (
                                <li key={notice._id} className="notice-list-item" onClick={() => navigate(`/notices/${notice._id}`)}>
                                    <h3>{notice.title}</h3>
                                    <p className="notice-date">
                                        작성일: {new Date(notice.createdAt).toLocaleDateString()}
                                        {isEdited && <span className="edited-tag"> (수정됨)</span>}
                                    </p>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </main>
        </div>
    );
}

export default NoticeListPage;